import { toast } from 'react-toastify';

const notifyRegistartionError = (message) => {
    switch (message) {
        case 'Firebase: Password should be at least 6 characters (auth/weak-password).':
            toast.error('הסיסמה צריכה להכיל לפחות 6 תווים');
            break;
        case 'Firebase: Error (auth/email-already-in-use).':
            toast.error('המייל כבר קיים במערכת');
            break;
        case 'Firebase: Error (auth/invalid-email).':
            toast.error('פורמט המייל אינו תקין');
            break;
        case 'Firebase: There is no user record corresponding to this identifier. The user may have been deleted. (auth/user-not-found).':
            toast.error('המייל לא תקין או לא נמצא במערכת');
            break;
        case 'Firebase: The password is invalid or the user does not have a password. (auth/wrong-password).':
            toast.error('הסיסמה לא תקינה או לא נכונה');
            break;
        case 'Firebase: Error (auth/internal-error).':
            toast.error('שגיאה! בדוק את הערכים שהכנסת');
            break;
        default:
            return null;
    }
};

const notifyLoginError = (message) => {
    console.log(message);
    switch (message) {
        case 'Firebase: Password should be at least 6 characters (auth/weak-password).':
            toast.error('הסיסמה צריכה להכיל לפחות 6 תווים');
            break;
        case 'Firebase: Error (auth/email-already-in-use).':
            toast.error('המייל תפוס על ידי משתמש אחר');
            break;
        case 'Firebase: Error (auth/invalid-email).':
            toast.error('פורמט המייל אינו תקין');
            break;
        case 'Firebase: Error (auth/user-not-found).':
            toast.error('המייל לא תקין או לא נמצא במערכת');
            break;
        case 'Firebase: The password is invalid or the user does not have a password. (auth/wrong-password).':
            toast.error('הסיסמה לא תקינה או לא נכונה');
            break;
        case 'Firebase: Error (auth/internal-error).':
            toast.error('בדוק את הערכים שהכנסת');
            break;
        case 'Firebase: Error (auth/wrong-password).':
            toast.error('הסיסמה אינה נכונה');
            break;
        default:
            return null;
    }
};

export { notifyLoginError, notifyRegistartionError };